import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const names = ['Camila G.', 'Dr. Matías R.', 'Dra. Sofía L.', 'Joaquín P.', 'Dra. Valentina M.', 'Dr. Ignacio D.', 'Florencia S.', 'Dr. Tomás A.', 'Dra. Micaela V.', 'Gonzalo B.'];
const cities = ['Córdoba', 'Rosario', 'CABA', 'La Plata', 'Mendoza', 'Mar del Plata', 'Salta', 'Neuquén', 'San Juan', 'Bahía Blanca', 'Tucumán', 'Santa Fe'];
function pick(list: string[]): string {
  return list[Math.floor(Math.random() * list.length)];
}
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState({
    name: names[0],
    city: cities[0],
    minutes: 3
  });
  useEffect(() => {
    let hideTimer: number;
    const show = () => {
      setPurchase({
        name: pick(names),
        city: pick(cities),
        minutes: Math.floor(Math.random() * 12) + 1
      });
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5500);
    };
    const firstTimer = window.setTimeout(show, 6000);
    const interval = window.setInterval(show, 18000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-164" data-mp="n6v5x1imhpvq">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm" role="status" aria-live="polite" data-id="element-165" data-mp="n7wmtmmbl6ld">
          <div className="flex items-start gap-3 rounded-2xl border border-teal-400/30 bg-[#0b2431]/95 p-3.5 shadow-2xl shadow-black/50 backdrop-blur" data-id="element-166" data-mp="s8atp1c6qaht">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-400" aria-hidden="true" data-id="element-167" data-mp="23m6642bpg55c" />
            <div className="min-w-0 flex-1" data-id="element-168" data-mp="2aobgywl24h0q">
              <p className="text-sm font-bold text-white" data-id="element-169" data-mp="2fn4sijgs9xy9">
                {purchase.name} de {purchase.city}
              </p>
              <p className="text-xs text-teal-100/80" data-id="element-170" data-mp="2ko2b2x5pgu0a">
                acaba de comprar el Kit Consultorio Sencillo
              </p>
              <p className="mt-0.5 text-[11px] text-teal-100/50" data-id="element-171" data-mp="2pjran0hq6awl">
                hace {purchase.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar aviso" className="rounded-full p-1 text-teal-100/60 hover:text-white" data-id="element-172" data-mp="1wwde33hxvhd0">
              <XIcon className="h-4 w-4" data-id="element-173" data-mp="26oj3c5gt3koi" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}